import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { OverlayTrigger, Popover } from "react-bootstrap";
import { UserHover } from "Components/UserHover";
import { useApplicantDetails } from "Constant/apiHooks";
import { formatDateWithFullMonth, getFirstLetterOfName } from "Utils";

export const Header = ({ gid, hideBackButton }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { applicantDetails, loading } = useApplicantDetails(gid);
  const [showUserPopover, setShowuserPopover] = useState(false);

  // Toggle
  const handleUserPopoverMouseEnter = () => {
    setShowuserPopover(true);
  };

  const handleUserPopoverMouseLeave = () => {
    setShowuserPopover(false);
  };

  return (
    <div className="applicant-status-header z-2">
      {!loading && applicantDetails && (
        <>
          <div className="d-flex flex-wrap align-items-center justify-content-between row-gap-2 column-gap-xl-5 column-gap-4">
            {!hideBackButton && (
              <button
                className="w-10 h-10 border-0 bg-transparent d-flex justify-content-center align-items-center"
                onClick={() => navigate(-1)}
              >
                <span className="material-symbols-outlined">arrow_back</span>
              </button>
            )}
            <div
              className=""
              onMouseEnter={handleUserPopoverMouseEnter}
              onMouseLeave={handleUserPopoverMouseLeave}
            >
              <OverlayTrigger
                placement="right"
                show={showUserPopover}
                overlay={
                  <Popover className="max-w-unset">
                    <UserHover user={applicantDetails} />
                  </Popover>
                }
              >
                <div className="d-flex align-items-center">
                  <div className="w-12 h-12 rounded-circle border-2 border-solid border-white overflow-hidden">
                    {applicantDetails.photoURL ? (
                      <div className="img-box w-100 h-100">
                        <img
                          src={applicantDetails.photoURL}
                          alt={`${applicantDetails.firstName}${applicantDetails.lastName}`}
                          className="w-100 h-100 object-fit-cover"
                        />
                      </div>
                    ) : (
                      getFirstLetterOfName(applicantDetails)
                    )}
                  </div>

                  <div className="avatar-short-dtls ms-2 d-flex flex-column row-gap-0">
                    <h3 className="h6 mb-0 text-nowrap">
                      {applicantDetails.firstName} {applicantDetails.lastName}
                    </h3>
                  </div>
                </div>
              </OverlayTrigger>
            </div>
            <div className="d-flex flex-column row-gap-0">
              <h4 className="h6 mb-0">
                {applicantDetails.projectText}
              </h4>
            </div>
            
            <div className="date d-flex gap-2">
              <small className="text-xs text-nowrap">
                {applicantDetails.decisionDate &&
                  formatDateWithFullMonth(applicantDetails.decisionDate)}
              </small>
            </div>
            <div className="status mx-3 py-2">
              <span className="badge py-2 px-3 rounded-pill text-bg-warning font-medium">
                {applicantDetails.status}
              </span>
            </div>
          </div>
        </>
      )}
    </div>
  );
};
